import { FC } from 'react';

import { useTranslation } from '@mopla/i18';

import {
	EMlpIconTypes,
	EMplVariantTypes,
	MplIconMessage,
} from '../MplIconMessage';

interface ISchoolCancellationDeadlineMessageProps {
	dataTestid?: string;
}
export const SchoolCancellationDeadlineMessage: FC<
	ISchoolCancellationDeadlineMessageProps
> = ({ dataTestid }) => {
	const { t } = useTranslation('tickets');

	return (
		<MplIconMessage
			type={EMlpIconTypes.Information}
			variant={EMplVariantTypes.Default}
			message={t('school_cancellation.deadline_info')}
			dataTestid={dataTestid}
		/>
	);
};
